import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const tumor: AnswerPathTreeNode = {
  path: 'tumor',
  children: [
    { path: 'bodyPart', nodeId: NodeIds.healthInsuredTumorBodyPart },
    { path: 'severity', nodeId: NodeIds.healthInsuredTumorSeverity },
  ],
};
